import { get } from 'lodash';
import {
  Box,
  Chip,
  FormHelperText,
  FormControl,
  TextField,
} from '@mui/material';
import Autocomplete from '@mui/material/Autocomplete';
import { useFormContext, Controller } from 'react-hook-form';

const CustomSelectChip = ({
  name,
  sx,
  label,
  options = [],
  multiple = true,
  MenuProps,
  formControlProps,
  maxShow = 3,
  ...params
}) => {
  const { control, formState } = useFormContext();
  const { errors } = formState;
  const parsedError = get(errors, name);

  return (
    <Controller
      {...params}
      name={name}
      control={control}
      render={({ field }) => {
        const { value, onChange } = field;
        const selectedValue = multiple
          ? options.filter((opt) => (value || []).includes(opt._id))
          : options.find((opt) => opt._id === value) || null;

        return (
          <FormControl
            size="small"
            fullWidth
            error={!!parsedError}
            sx={sx}
            {...formControlProps}
          >
            <Autocomplete
              multiple={multiple}
              disableCloseOnSelect={multiple}
              options={options}
              value={selectedValue}
              onChange={(event, newValue) => {
                if (multiple) {
                  onChange(newValue.map((item) => item._id));
                } else {
                  onChange(newValue ? newValue._id : '');
                }
              }}
              getOptionLabel={(option) => option?.label ?? ''}
              isOptionEqualToValue={(option, val) => option?._id === val?._id}
              renderTags={(selected, getTagProps) => (
                <Box
                  sx={{
                    display: 'flex',
                    flexWrap: 'wrap',
                    gap: 0.5,
                    padding: 0,
                  }}
                >
                  {selected.map((option, index) => {
                    if (index < maxShow) {
                      const tagProps = getTagProps({ index });
                      return (
                        <Chip
                          {...tagProps}
                          key={option._id}
                          label={option?.label}
                          sx={{
                            height: '26px',
                            fontWeight: 500,
                            overflow: 'hidden',
                            textOverflow: 'ellipsis',
                            width:
                              option?.label?.length > 10 ? '110px' : 'inherit',
                          }}
                        />
                      );
                    }
                    return null;
                  })}
                  {selected.length > maxShow ? (
                    <Chip
                      key={`+${selected.length - maxShow}`}
                      sx={{ height: '26px', fontWeight: 500 }}
                      label={`+${selected.length - maxShow}`}
                    />
                  ) : null}
                </Box>
              )}
              renderInput={(renderParams) => (
                <TextField
                  {...renderParams}
                  label={label}
                  size="small"
                  error={!!parsedError}
                  InputLabelProps={{ shrink: true }}
                />
              )}
            />
            <FormHelperText>{parsedError?.message || ''}</FormHelperText>
          </FormControl>
        );
      }}
    />
  );
};

export default CustomSelectChip;
